var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPictureFrame = function SvgPictureFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.065 2.095C3.423.76 5.455.25 8.074.25h6.106c2.619 0 4.65.51 6.009 1.845C21.547 3.429 22.066 5.426 22.066 8v6c0 2.574-.52 4.57-1.877 5.905-1.358 1.335-3.39 1.845-6.01 1.845H8.075c-2.62 0-4.651-.51-6.01-1.845C.708 18.571.188 16.574.188 14V8c0-2.574.52-4.57 1.878-5.905Zm1.079 1.06c-.932.916-1.43 2.419-1.43 4.845v6c0 2.426.498 3.93 1.43 4.845.932.915 2.461 1.405 4.93 1.405h6.106c2.468 0 3.998-.49 4.93-1.405.931-.916 1.43-2.419 1.43-4.845V8c0-2.426-.499-3.93-1.43-4.845-.932-.915-2.462-1.405-4.93-1.405H8.074c-2.469 0-3.998.49-4.93 1.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.893.272c.409-.1.822.146.924.548l5.037 20a.75.75 0 0 1-.558.908.764.764 0 0 1-.924-.548l-5.037-20a.75.75 0 0 1 .558-.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.381 11.01a.748.748 0 0 1-.519.93l-9.697 2.78a.765.765 0 0 1-.947-.51.748.748 0 0 1 .52-.93l9.697-2.78a.765.765 0 0 1 .946.51Z"
  }))));
};
export default SvgPictureFrame;